
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {   fetchSettings}  from 'shared/sharedMethods';
import {
    makeRequest,getErrorCode,
    dispatchAction,
    displayMessage
} from 'actions';
import { Button} from 'react-bootstrap';
import config from  '../../config';
import {  Link } from 'react-router';

import {USER_LOGOUT,UPDATE_APP_DATA,
    UPDATE_USER_DATA
} from "actions/actionTypes";




class SellerDashboardPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }
    constructor(props, context) {
        super(props, context);
        this.state={
            userDataReceived:_.get(this.props.userReducer, ['user', '_id'], false) ? true:false,
        }
      };

    componentWillMount() {
console.log('in dashboard', _.get(this.props, ['location', 'query', 'customerid'], false), this.props.userReducer );
        /* get user data if  user._id is not available and customer id is passed */
        /* or if  user._id is available and passed customer id is not equal to current user ShopifyCustomerID, can happen if user logs in to another account on Shopify */
       if(_.get(this.props, ['location', 'query', 'customerid'], false)){
        if ((!_.get(this.props.userReducer, ['user', '_id'], false) && _.get(this.props, ['location', 'query', 'customerid'], false))
            || (_.get(this.props.userReducer, ['user', '_id'], false) && _.get(this.props, ['location', 'query', 'customerid'], false) && _.get(this.props, ['location', 'query', 'customerid'], false) !== _.get(this.props.userReducer, ['user', 'ShopifyCustomerID'], false))
        ) {
            this.props.dispatchAction({}, USER_LOGOUT)
            /* remove token for the current user */
        }
             this.setState({userDataReceived:false})
            var methodData = {
                'endpoint': '/get-user-data-with-query',
                "success_event": UPDATE_USER_DATA,
                'type': 'post',
                 'not_display_error_message': true,
            };
             this.props.makeRequest({ShopifyCustomerID: _.get(this.props, ['location', 'query', 'customerid'], false)}, methodData).then(res => {
                console.log('userDataReceived', res  );
                var dataToUpdate = {userDataReceived:true}
                if (!_.get(res.data, 'User._id')){
                    dataToUpdate.userNotFound = true
                    this.props.displayMessage({
                        'messageType': 'warning',
                        'messageCode': 'User not found by ID: ' + _.get(this.props, ['location', 'query', 'customerid'], false)

                    });
                }
                 this.setState(dataToUpdate)
            }).catch(err =>{
                 if( config.apiErrorCodeMap[getErrorCode(err)] == 'RecordNotFound'){
                     this.setState({userDataReceived: true, userNotFound: true})
                 }
            })
            //     .catch(function (err) {
            //     console.log('err', err  );
            //     if (!_.get(err, ['user', '_id'], false)) {
            //     this.props.dispatchAction({}, USER_LOGOUT)
            // }
            // })
        }
     //   var classList = _.get(window.top.document.body, ['classList'], []).contains
        if ( config.getEnvironmentName() == 'local' ||   window.self != window.top) {
            window.self.document.body.classList.add('in-frame');
        }

      fetchSettings.call(this,'FeatureFlags').then(result => {
        this.props.dispatchAction({
          FeatureFlags:result,
        }, UPDATE_APP_DATA);
      }).catch(err=>{
        console.log('server error', err  );
      });
    }
    sendDataForIframe() {
         if (  window.parent) {
             var iframeData = {
                 'eventName': 'setSchedulePickupFormHeight',
                 pickupFormHeight: 300,
             }
            if( _.includes(this.props.location.pathname, '/dashboard/subscriptions')){
                iframeData ={
                    'eventName': 'setIframeHeight',
                    'elementID':'subscriptionsList',
                    height:300,
                }
            }  else if( _.includes(this.props.location.pathname, '/dashboard/products')){
                iframeData ={
                    'eventName': 'setIframeHeight',
                    'elementID':'productsList',
                    height:300,
                }
             }else if( _.includes(this.props.location.pathname, '/dashboard/settings')){
                iframeData ={
                    'eventName': 'setIframeHeight',
                    'elementID':'sellerData',
                    height:300,
                }
            }else if( _.includes(this.props.location.pathname, '/dashboard/referrals')){
                iframeData ={
                    'eventName': 'setIframeHeight',
                    'elementID':'referralsPage',
                    height:300,
                }
            }
             window.parent.postMessage(iframeData, "*");
        }
    }
    render() {
        console.log('this.props.userReducer', _.get(this.props, ['location' ], false), this.props.userReducer, this.state.userDataReceived);
        if (!this.state.userDataReceived) {
            return null
        }
        if (!_.get(this.props.userReducer, ['user', '_id'], false)) {
            if (_.get(this.state, 'userNotFound')) {
                this.sendDataForIframe()
                return <h3 className="message-box">Sorry, user record not found</h3>
            }
             return null;


        } else {
            if (!_.get(this.props.userReducer, ['seller', '_id'], false) &&  /dashboard\/products|dashboard\/services|dashboard\/settings/i.test(this.props.location.pathname)){
                console.log('not seller'  );
                this.sendDataForIframe()
                return <div>
                    <div className="message-box">
                        <a className="btn btn-primary" target="_blank"
                           href={ 'https://goodbuygear.com/pages/schedule-a-white-glove-pickup-service'}>Sign-up to Sell</a>
                    </div>

                </div>
            }


            return (
                <div                  // className="dashboard top30"
                    className=" top30"
                >
                    { window.self == window.top &&
                    <div className="navigation-box left10  bot15">
                        <Button bsStyle="link" className="nav-box-header">
                            <Link to={'/client/dashboard/products'}>Seller Account</Link>
                        </Button>
                        <Button className="nav-box-header" bsStyle="link">
                            <Link to={'/client/dashboard/settings'}>Seller Profile</Link>
                        </Button>
                        <Button className="nav-box-header" bsStyle="link">
                            <Link to={'/client/dashboard/services'}>White Glove Services</Link>
                        </Button>
                        <Button className="nav-box-header" bsStyle="link">
                        <Link to={'/client/dashboard/subscriptions'}>Favorites</Link>
                    </Button>
                        {config.getEnvironmentName() !== 'production' &&
                        <Button className="nav-box-header" bsStyle="link">
                        <a className=" " target="_blank"
                           href={ 'https://goodbuygear.com/pages/invite-your-friends'}>Friends</a>
                        </Button>
                        }
                    </div>
                    }

                    <div className="container"> {this.props.children }  </div>
                </div >
            );
        }
    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
     };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SellerDashboardPage);
